import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { formatDate } from "../../utils";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);
/*title: string,
  backgroundColor?: string,
  borderColor?: string,
  borderWidth?: number*/
const TrendsGraph = ({
  payloadData,
  title,
  backgroundColor,
  borderColor,
  borderWidth,
}) => {
  const labels = payloadData.map((o) => o.date);
  const values = payloadData.map((o) => (o.value ? o.value * 100 : 0));
  const data = {
    labels, //["January", "February", "March", "April", "May", "June"],
    datasets: [
      {
        label: title, //"Stress",
        data: values,
        fill: true,
        backgroundColor: backgroundColor
          ? backgroundColor
          : "rgba(255,255,255,0.2)", //"rgba(75, 192, 192, 0.2)",
        borderColor: borderColor ? borderColor : "rgba(255,255,255,1)", //"rgba(75, 192, 192, 1)",
        borderWidth: borderWidth ? borderWidth : 1, //1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,

    plugins: {
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: false,
        text: title + " Chart",
      },
    },
    scales: {
      y: {
        min: 0,
        max: 100,
        beginAtZero: true,
        display: true,
      },
      x: {
        display: true,
      },
    },
    elements: {
      point: {
        radius: 5,
      },
    },
  };

  return <Line data={data} options={options} />;
};

export default TrendsGraph;
